import { PageNamesTypes } from '../src/types';
import type { PageName } from '../src/types';

import type { PeopleUserBagPageQuery } from './graphql/user-bag-page-by-username.query.gql-types';

export const sanitizeNames = (
  names: NonNullable<
    NonNullable<PeopleUserBagPageQuery['peopleUserBagPage']>['names']
  >
): Array<PageName> => {
  return (
    names
      ?.map((name): PageName | null => {
        switch (name?.__typename) {
          case 'PeopleProfileItem': {
            return {
              __typename: PageNamesTypes.profile,
              name: name?.name || '',
              photoUrl: name?.photoUrl || '',
              coach: name?.coach || false,
              url: name?.url || '',
              occupationTitle: name?.occupationTitle || '',
              city: name?.city || '',
            };
          }
          default: {
            return null;
          }
        }
      })
      .reduce<Array<PageName>>((result, name: PageName | null) => {
        if (name) {
          return [...result, name];
        } else {
          return result;
        }
      }, []) || []
  );
};
